var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.6,
    height: 17.6,
    viewBox: "0 0 17.6 17.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wind",
    transform: "translate(-3.2 -3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6636",
    "data-name": "Path 6636",
    d: "M4,8.414H15.586a2.207,2.207,0,0,0,2.207-2.207h0A2.207,2.207,0,0,0,15.586,4H14.345",
    fill: "none",
    stroke: "#17249a",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6637",
    "data-name": "Path 6637",
    d: "M4,11.724H17.517A2.483,2.483,0,0,1,20,14.207h0a2.483,2.483,0,0,1-2.483,2.483H16",
    fill: "none",
    stroke: "#17249a",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6638",
    "data-name": "Path 6638",
    d: "M4,15.035H8.138a2.483,2.483,0,0,1,2.483,2.483h0A2.483,2.483,0,0,1,8.138,20h-1.1",
    fill: "none",
    stroke: "#17249a",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.486aa708f2e827f4bc6c28c831120af9.svg";
export { ForwardRef as ReactComponent };